import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ExaVault from "./ExaVault";
import CreateJob from "./CreateJob";
import Header from "./Header";

class Dashboard extends Component {
  render() {
    return (
      <div className="main-content">
        <Header />
        <div className="container-main">
          <div className="exavault" style={{ width: "80%", height: "100%" }}>
            <div
              id="exavault-share-widget"
              style={{ width: "100%", height: "775px" }}
            ></div>

            <ExaVault />
          </div>
          <div className="create-job" style={{ width: "20%" }}>
            <CreateJob />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Dashboard);
